/**
 * Cart service for handling cart data from different sources.
 *
 * @since 1.0.0
 */

import { popupManager } from '@/frontend/components';
import type { RedFoxCartData } from '@/frontend/types/cart';

/**
 * Handle cart data from WooCommerce filter.
 *
 * @since 1.0.0
 *
 * @param cartData Cart data from PHP filter.
 *
 * @return void
 */
export const handleCartDataFromFilter = (cartData: RedFoxCartData): void => {
  if (!cartData.products || cartData.products.length === 0) {
    return;
  }

  // All products in cartData.products are the ones that were just added.
  // For grouped products, this could contain multiple products.
  // We pass the first product as the primary product and the complete cartData.
  // The CartPopupContent component will handle displaying all products appropriately.
  const primaryProduct = cartData.products[0];
  if (primaryProduct) {
    popupManager.showCart(primaryProduct, cartData, 'wc-cart-added');
  }
};
